import { ConsultantsQuerySskFormInput, SelectType } from "@graphql";

export const sskInitialValues: ConsultantsQuerySskFormInput = {
  areaOfExpertise: {
    type: SelectType.ANY,
    value: []
  },
  specializations: {
    type: SelectType.ANY,
    value: []
  }
};
